import cx from 'classnames'
import Dropdown from 'rc-dropdown'
import Menu, { Item as MenuItem } from 'rc-menu'

import { ArrowDropdownDown } from 'common/icons'

import Button, { ButtonProps } from './button/Button'

import 'rc-dropdown/assets/index.css'

export interface ButtonOptionsProps {
  key: string
  label: string
  onClick: () => void
  isDisabled?: boolean
}

interface ButtonWithDropdownProps extends ButtonProps {
  animation?: string
  placement?: string
  overlayClassName?: string
  options: ButtonOptionsProps[] | undefined
}

const menu = (options: ButtonOptionsProps[] | undefined) => (
  <Menu className="shadow box-border py-2 z-40 rounded-md" selectable={false}>
    {options?.map((option) => (
      <MenuItem
        disabled={option.isDisabled}
        key={option.key}
        onClick={option.onClick}
        className={cx(
          {
            'cursor-not-allowed pointer-events-auto': option.isDisabled,
            'cursor-pointer': !option.isDisabled,
          },
          'bg-white h-8 pl-4 pr-8 hover:bg-coolGray-50 text-coolGray-600 font-medium '
        )}
      >
        {option.label}
      </MenuItem>
    ))}
  </Menu>
)

export const ButtonWithDropdown = ({
  animation = 'slide-up',
  options,
  className,
  children,
  variant,
  overlayClassName,
  placement = 'bottomRight',
  ...rest
}: ButtonWithDropdownProps) => {
  return (
    <Dropdown
      overlayClassName={overlayClassName}
      trigger={['click']}
      overlay={menu(options)}
      animation={animation}
      placement={placement}
    >
      <Button
        className={className}
        variant={variant}
        suffixIcon={<ArrowDropdownDown isDefaultColor={false} />}
        {...rest}
      >
        {children}
      </Button>
    </Dropdown>
  )
}

export default ButtonWithDropdown
